import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from '../Form/Form';
import { PageLayout } from '../PageLayout/PageLayout';

interface AppProps {}

export const App: React.FC<AppProps> = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.history.replaceState(
      '',
      'Unknown charge',
      '/billing/unknown-charge',
    );
  }, []);

  return (
    <PageLayout
      title={t('charge-locator.charge-locator-form.title')}
      subtitle={t('charge-locator.charge-locator-form.subtitle')}
    >
      <Form />
    </PageLayout>
  );
};
